import { useContext, useEffect, useMemo, useState } from "react"
import { useCommanKit } from "./useCommanKit";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";

export const useJoiningReport = ({ data, onNext }) => {
    const { getEmployeeDetails } = useCommanKit({ data });
    const [checkedIds, setCheckedIds] = useState([]);
    const [documents, setDocuments] = useState([]);
    const { showSuccess, showError } = useContext(ToastContext);
    const [isChanged, setIsChanged] = useState(false)

    useEffect(() => {
        const group = _.find(data?.attributeGroup, { attribute_group_key: "joining_report_document" });
        if (group) {
            const options = _.filter(data?.attributeItems, { attribute_group_id: group.attribute_group_id })
                .map(item => ({
                    label: item.item_name,
                    value: item.attribute_item_id
                }));
            setDocuments(options);
        }
    }, [data?.attributeGroup, data?.attributeItems]);

    useEffect(() => {
        data?.employee?.user_code && getEmployeeDetails("employee_joining_report", data?.employee?.user_code).then((res) => {
            setCheckedIds(_.pluck(res?.employee_joining_report, "document_item_id"))
        }).catch((error) => {
            console.error(error)
        })
    }, [data?.employee]);

    const handleCheckboxChange = (document_item_id) => {
        setIsChanged(true)
        setCheckedIds((prev) =>
            prev.includes(document_item_id)
                ? prev.filter((id) => id !== document_item_id)
                : [...prev, document_item_id]
        );
    };



    const handleSubmit = async () => {
        if (!isChanged) {
            onNext();
            return;
        }
        const payload = {
            document_item_ids: checkedIds?.toString() || ""
        };
        try {
            const res = await services.getInvokeRemote("POST", Urls("UPSERTEMPLOYEEJOININGREPORTDETAILS"), payload);
            if (!res?.body?.error_status) {
                showSuccess('Sucess', res.body.message)
                onNext()
            } else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error("Upsert error", error);
        }
    };


    return useMemo(() => ({
        checkedIds, handleCheckboxChange, documents, handleSubmit
    }), [checkedIds, handleCheckboxChange, documents, handleSubmit])
}